const Color = {
  ORANGE: '#FF7500',
  BLACK: '#1D1D1B',
  CHARCOAL: '#3B3C43',
  STONE: '#E9EAE8',
  WHITE: '#FFFFFF',
  TEAL: '#006272',
  BLUE: '#0762C8',
  SLATE: '#605D75',
  SLATE_LIGHT: '#8480a1',
  SMOKE: '#887C77',
  POWDER: '#D5DEF2',
}

export default Color;


// WEBPACK FOOTER //
// ./src/styles/colors.js